import DB from "@/common/utils/db";

//猎头挂靠申请

export function hcApplies(query) {
  return DB({
      url: "v1/headhunterSubordinateApplies",
      method: "post",
      params: query
  });
}

//猎头寻求工作

export function hhApplies(query) {
  return DB({
      url: "v1/headhunterworkapplies",
      method: "post",
      params: query
  });
}

export function comApplies(query) {
  return DB({
      url: "v1/companycooperationapplies",
      method: "post",
      params: query
  });
}
//获取项目对焦录音
export function getProjectTapeDetail(query) {
  return DB({
    url: "v1/talents/tagBaseViews",
    method: "get",
    params: query
  });
}